import { render, staticRenderFns } from "./RankingCard.vue?vue&type=template&id=237357ca"
import script from "./RankingCard.vue?vue&type=script&lang=js"
export * from "./RankingCard.vue?vue&type=script&lang=js"
import style0 from "./RankingCard.vue?vue&type=style&index=0&id=237357ca&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports